// Initialisation de l'objet queryParams pour stocker les paramètres de requête
Shopify.queryParams = {};

/*********************************************************************************************
* Refresh the collection page with the provided filters.
	* 
	* @param {string} url_filters - The URL parameters for the filters.
*/
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;

    let newUrl = currentUrl + '?' + (url_filters || '');
    newUrl = newUrl.replace(/%26/g, '&').replace(/%3D/g, '=');

    let newPageString = httpGet(newUrl);
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    // Mise à jour des articles de la collection avec les nouveaux filtres
    var newSection = newPageEl.querySelector('.mm-grid-card-collection');
    document.querySelector('.mm-grid-card-collection').innerHTML = newSection.innerHTML;

    // Mise à jour des filtres actifs
    var activeFilters = newPageEl.querySelectorAll('.active-filters');
    activeFilters.forEach(function (activeFilter) {
        var newActiveFilters = document.querySelectorAll('.active-filters');
        newActiveFilters.forEach(function (newActiveFilter) {
            newActiveFilter.innerHTML = activeFilter.innerHTML;
        });
    });

    var filters = newPageEl.querySelectorAll('.mm-filter-list');
    filters.forEach(function (filter, index) {
        var newFilters = document.querySelectorAll('.mm-filter-list');
        newFilters[index].innerHTML = filter.innerHTML;
    });
    
    // Mise à jour des autres éléments avec la classe 'mm-reload'
    var reloadElems = newPageEl.querySelectorAll('.mm-reload');
    reloadElems.forEach(function (reloadElem, index) {
        var newElems = document.querySelectorAll('.mm-reload');
        newElems[index].innerHTML = reloadElem.innerHTML;
    });

    // Mise à jour de l'URL dans l'historique sans recharger la page
    window.history.replaceState(null, document.title, newUrl);
    document.querySelector('.mm-grid-card-collection').classList.remove('mm-loading');
    
    // Vérifie les changements dans les filtres après le rafraîchissement
    checkForChanges();
}

/*********************************************************************************************
* Return the Shopify section ID of the collection grid.
	* 
	* @returns {string} - The section ID of the grid.
*/
function returnShopifySectionId() {
    const gridElem = document.querySelector('.mm-collection-grid');
    const gridSection = gridElem.closest('.shopify-section');
    return gridSection.id;
}

/*********************************************************************************************
* Return the Shopify section ID without the 'shopify-section-' prefix.
	* 
	* @returns {string} - The shortened section ID.
*/
function returnShopifySectionIdShort() {
    return returnShopifySectionId().replace('shopify-section-', '');
}

/*********************************************************************************************
* Perform a synchronous GET request.
	* 
	* @param {string} theUrl - The URL to request.
	* @returns {string} - The response text from the request.
*/
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);  // Synchronous request
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/*********************************************************************************************
* Check for changes in the filter inputs and submit the form if changes are detected.
	*	
*/
function checkForChanges() {
    
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');

    // Ajouter un listener sur chaque input pour détecter les changements
    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            fakeSubmitForm();
        });
    });
}


/*********************************************************************************************
* Update the sort_by query parameter and reload the page with the new sorting applied.
	* 
	* @param {HTMLSelectElement} select - The select element for sorting.
*/
function mmSortByChanged(select) {
    const hiddenSelect = document.getElementById('mmSortByHiddenElem');
    hiddenSelect.value = select.value;
    fakeSubmitForm();
}

/*********************************************************************************************
* Adds a listener on the change of select for sorting
	* 
*/
document.querySelector('.sort_by').addEventListener('change', function(e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});

/*********************************************************************************************
* Serialize the form data and refresh the collection page with the filters.
	*
*/
function fakeSubmitForm() {
    let form = document.getElementById("collectionFacetsForm");
    let url_filters = new URLSearchParams(new FormData(form)).toString();
    if (!url_filters.includes('filter.v.availability=1')) {
        url_filters += (url_filters ? '&' : '') + 'filter.v.availability=1';
    }
    document.querySelector('.mm-grid-card-collection').classList.add('mm-loading');
    
    // Rafraîchir la collection avec les filtres
    setTimeout(() => {
        refreshCollectionPageWithFilters(url_filters);
    }, "0");
}

/*********************************************************************************************
* Mobile filter drawer functions for screens smaller than 900px.
	*
*/
    
/*********************************************************************************************
* Open the mobile filters drawer.
    *
*/
function mmOpenFiltersMobile() {
    var wrapperMobile = document.querySelector('.mm-collection-grid-filter-container');
    wrapperMobile.classList.add('mm-open');
    document.querySelector('html').classList.add('stop-scrolling');  // Empêche le scroll en arrière-plan
}

/*********************************************************************************************
* Close the mobile filters drawer.
    *
*/
function mmCloseFiltersMobile() {
    var wrapperMobile = document.querySelector('.mm-collection-grid-filter-container');
    wrapperMobile.classList.remove('mm-open');
    document.querySelector('html').classList.remove('stop-scrolling');  // Réactive le scroll
}

/*********************************************************************************************
* Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
    * 
*/
function mmCheckDrawer() {
    var currentUrl = document.location.href.indexOf('?open_filters');
    if (currentUrl !== -1) {
        mmOpenFiltersMobile();
    }
}

/*********************************************************************************************
* Loaded Listenner
	*
*/
window.addEventListener('DOMContentLoaded', (event) => {
    checkForChanges();
});